import { gql } from "graphql-request";

export const tenants = {
  tenants: gql`
    query Tenants {
      tenants {
        id
        name
        lastPollDate
      }
    }
  `,
};
